<template>
  <div >
    <div class="w-12 h-12 flex flex-row justify-center flex-no-shrink cursor-pointer" 
      v-bind:class="[selectedTab === 'patient-history' ? 'border-l-4 border-solid border-blue' : '',]" 
      @click="tabClicked('patient-history')" title="Patient History">
        <img class="h-6 w-6 self-center" v-bind:class="[selectedTab === 'patient-history' ? '-ml-1' : 'opacity-50',]" src="../assets/patient_history.png" alt="chat_icon">
    </div>
    <div class="w-12 h-12 flex flex-row justify-center flex-no-shrink cursor-pointer" 
      v-bind:class="[selectedTab === 'drugs' ? 'border-l-4 border-solid border-blue' : '',]" 
      @click="tabClicked('drugs')" title="Prescribe Drugs">  
        <img class="h-6 w-6 self-center" v-bind:class="[selectedTab === 'drugs' ? '-ml-1' : 'opacity-50',]" src="../assets/medications.png" alt="chat_icon">
    </div>
    <div class="w-12 h-12 flex flex-row justify-center flex-no-shrink cursor-pointer" 
      v-bind:class="[selectedTab === 'order-labs' ? 'border-l-4 border-solid border-blue' : '',]"
      @click="tabClicked('order-labs')" title="Order Labs">  
        <img class="h-6 w-6 self-center" v-bind:class="[selectedTab === 'order-labs' ? '-ml-1' : 'opacity-50',]" src="../assets/order_labs.png" alt="chat_icon">
    </div>
    <div class="w-12 h-12 flex flex-row justify-center flex-no-shrink cursor-pointer" 
      v-bind:class="[selectedTab === 'patient-documents' ? 'border-l-4 border-solid border-blue' : '',]"
      @click="tabClicked('patient-documents')" title="Documents">
        <img class="h-6 w-6 self-center" v-bind:class="[selectedTab === 'patient-documents' ? '-ml-1' : 'opacity-50',]" src="../assets/document.png" alt="chat_icon">    
    </div>
    <div class="w-12 h-12 flex flex-row justify-center flex-no-shrink cursor-pointer" 
      v-bind:class="[selectedTab === 'customer-past-consults' ? 'border-l-4 border-solid border-blue' : '',]"
      @click="tabClicked('customer-past-consults')" title="Past Consultations">
        <img class="h-6 w-6 self-center" v-bind:class="[selectedTab === 'customer-past-consults' ? '-ml-1' : 'opacity-50',]" src="../assets/past_consultation.png" alt="chat_icon">
    </div>
    <!-- <div class="w-12 h-12 flex flex-row justify-center flex-no-shrink cursor-pointer" 
      v-bind:class="[selectedTab === 'forms' ? 'border-l-4 border-solid border-blue' : '',]"
      @click="tabClicked('forms')">
        <img class="h-6 w-6 self-center" v-bind:class="[selectedTab === 'forms' ? '-ml-1' : 'opacity-50',]" src="../assets/form.png" alt="chat_icon">
    </div> -->
    <div class="w-12 h-12 flex flex-row justify-center flex-no-shrink cursor-pointer" 
      v-bind:class="[selectedTab === 'health-coach' ? 'border-l-4 border-solid border-blue' : '',]" 
      @click="tabClicked('health-coach')" title="Health Coach">
        <img class="h-6 w-6 self-center" v-bind:class="[selectedTab === 'health-coach' ? '-ml-1' : 'opacity-50',]" src="../assets/health_coach.png" alt="chat_icon">
    </div>
    <div class="w-12 h-12 flex flex-row justify-center flex-no-shrink cursor-pointer" 
      v-bind:class="[selectedTab === 'consultation-summary' ? 'border-l-4 border-solid border-blue' : '',]"
      @click="tabClicked('consultation-summary')" title="Summary"> 
        <img class="h-6 w-6 self-center" v-bind:class="[selectedTab === 'consultation-summary' ? '-ml-1' : 'opacity-50',]" src="../assets/summary.png" alt="chat_icon">    
    </div>
    <div v-if="customer && customer.isFamilyDoctor" class="w-12 h-12 flex flex-row justify-center flex-no-shrink cursor-pointer" 
      v-bind:class="[selectedTab === 'notification' ? 'border-l-4 border-solid border-blue' : '',]"
      @click="tabClicked('notification')" title="Summary"> 
        <img class="h-6 w-6 self-center" v-bind:class="[selectedTab === 'notification' ? '-ml-1' : 'opacity-50',]" src="../assets/bell-blue.svg" alt="chat_icon">  
        <div v-if="notViewedNotifications > 0" class="flex bg-red justify-center items-center rounded-full flex-no-grow flex-no-shrink cursor-pointer w-5 h-5 mt-2 ml-2" style="border-radius:50%; position:absolute;">
          <p class="flex flex-col self-center justify-center text-xs text-white">{{notViewedNotifications}}</p>
        </div> 
    </div>
    <UnsavedChangesModal v-if="showSaveReminder" @close='closeModal'/>    
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import UnsavedChangesModal from '@/components/common/modals/UnsavedChanges'
export default {
  props: ['selectedTab'],
  components: {
    UnsavedChangesModal
  },
  data () {
    return {
      showSaveReminder: false
    }
  },
  computed: {
    ...mapState({
      editTextField: state => state.textField.inEdit
    }),
    ...mapGetters({
      customer: 'configuration/getActivePatientProfile'
    }),
    notViewedNotifications: function () {
      if (this.customer) {
        if (this.customer.details && this.customer.details.notifications) {
          let noti = this.customer.details.notifications.filter(function (ele) {
            return !ele.is_viewed
          })
          return noti.length > 0 ? noti.length : 0
        }
      }
      return 0
    }
  },
  watch: {
    customer: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal && !newVal.isFamilyDoctor && this.selectedTab === 'notification') {
          this.tabClicked('patient-history')
        }
      }
    }
  },
  methods: {
    tabClicked: function (tab) {
      if (this.editTextField) {
        this.showSaveReminder = true
        return
      }
      this.$emit('tabChange', tab)
      if (tab === 'notification') {
        this.$store.dispatch('configuration/updateViewedNotification')
      }
    },
    closeModal: function () {
      this.showSaveReminder = false
    }
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/TabMenu.vue